export class InsuranceDto {
    public categoryCode?: string;
    public basesAmount: any = {};
    public deductible: any = {};

    constructor(categoryCode = null, basesAmount = {}, deductible={}){
        this.categoryCode=categoryCode;
        this.basesAmount=basesAmount;
        this.deductible=deductible;
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/insurance/insurance-dto.ts